"use strict";

exports.__esModule = true;
exports.default = toBufferView;
var _getByteLength = _interopRequireDefault(require("./_getByteLength.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Internal function to wrap or shallow-copy an ArrayBuffer,
// typed array or DataView to a new view, reusing the buffer.
function toBufferView(bufferSource) {
  return new Uint8Array(bufferSource.buffer || bufferSource, bufferSource.byteOffset || 0, (0, _getByteLength.default)(bufferSource));
}